<template>
  <div>
    <v-tooltip top v-if="tooltip">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          @click="$emit('click')"
          small
          icon
          :disabled="disabled"
          :to="to"
          style="border: 2px solid #e2e2e5; background-color: white"
          :color="color"
        >
          <v-icon small>{{ icon }}</v-icon>
        </v-btn>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
    <v-btn
      v-else
      @click="$emit('click')"
      small
      icon
      :disabled="disabled"
      :to="to"
      style="border: 2px solid #e2e2e5; background-color: white"
      :color="color"
    >
      <v-icon small>{{ icon }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: "secondary",
    },
    icon: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
      default: "",
    },
    to: {
      type: [String, Object],
      required: false,
      default: null,
    },
  },
};
</script>
